import {  createContext, useContext, useReducer} from "react";



const CartStateContex= createContext()
const CardDispatchContex = createContext()




const reducer=(state , action)=>{
   
     switch (action.type){
        case "AddData":
            return [...state,{id: action.id, name: action.name, qty: action.qty, size: action.size, price: action.price, img: action.img }]

            case "REMOVE":
            let newArr = [...state]
            newArr.splice(action.index, 1)
            return newArr;
            
            case "UPDATE":
            let arr = [...state]
            arr.find((food, index) => {
                if (food._id === action.id) {
                    arr[index] = { ...food, qty: parseInt(action.qty) + food.qty, price: action.price + food.price }
                }
                return arr
            })
            
            return arr

            case "DROP":
                let emptyArray=[]
                return emptyArray
            
        default:
            console.log("Error in Reducer")
    }
};

export const CartProvider=({children})=>{
    const [state , dispatch] =useReducer(reducer , [])

    return (
        <CardDispatchContex.Provider value={dispatch}>
            <CartStateContex.Provider value={state}>
                {children}
            </CartStateContex.Provider>
        </CardDispatchContex.Provider>
    )
};


export const useCart=()=>useContext(CartStateContex)
export const useDispatchCart=()=>useContext(CardDispatchContex)